import { ApplicationConfig , isDevMode, provideCheckNoChangesConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAuth } from '@libs/auth';
import { VERSION_INFO } from '@libs/ui/version/version-info';
import { APP_INFO, AppInfo } from '@libs/ui/sign-in/app-info';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { versionInfo } from '../environments/version-info';

export const appConfig: ApplicationConfig = {
  providers: [
    // zoneless (default since v21): in dev, flag any binding that changed without a signal, event or markForCheck
    ...(isDevMode() ? [provideCheckNoChangesConfig({ exhaustive: true })] : []),
    provideRouter(routes),
    provideAuth({
      baseUrl: environment.baseUrl,
      signInPath: '/identity/v1/auth/staffs/signIn',
      refreshPath: '/identity/v1/auth/staffs/refreshToken',
      userField: 'staff',
      userStorageKey: environment.userKey,
      refreshTokenExpMinutes: environment.refreshTokenExpMinutes,
      loginPath: '/',
      reloadOnLogout: true,
    }),
    { provide: VERSION_INFO, useValue: versionInfo },
    // the six values the shared sign-in page needs (juno docs/ui/sign-in.md §9). "Support and QA
    // console" names the domain and stops: the old line announced a testing tool with backend
    // reach, on a page anyone who finds the URL can read.
    {
      provide: APP_INFO,
      useValue: {
        name: 'Argus',
        purpose: 'Support and QA console',
        credentialHint: 'Use a salon staff account.',
        homePath: '/customers',
        lore: {
          title: 'Argus Panoptes',
          story:
            'The hundred-eyed giant Juno set to keep watch, who never closed more than half his ' +
            'eyes at once. When he was finally killed, his hundred eyes were set into the ' +
            "peacock's tail. Nothing got past him while he was awake, which was always.",
        },
      } satisfies AppInfo,
    },
  ],
};
